module.exports = {"131081001":"裕华街道","131081100":"霸州镇","131081101":"南孟镇","131081102":"信安镇","131081103":"堂二里镇","131081104":"煎茶铺镇","131081105":"胜芳镇","131081106":"杨芬港镇","131081107":"康仙庄镇","131081108":"王庄子镇","131081200":"岔河集乡","131081202":"东杨庄乡","131081204":"东段乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/131081.json
// module id = 328
// module chunks = 0